import { useLocation } from "@tanstack/react-router";

/** Which mode the app is in, derived from the URL (routing is the source of
 * truth). Plan mode has its own base route, independent of any workspace:
 * `/plan/…` → "plan"; everything else (incl. `/w/$slug/…` Act routes) → "act". */
export function usePlanMode(): "act" | "plan" {
  const seg = useLocation().pathname.split("/");
  // ["", "plan", ...] → Plan mode (workspace-independent base route).
  return seg[1] === "plan" ? "plan" : "act";
}
